import { Button } from '@mui/material'
import { Box } from '@mui/system'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'

const SummariesBtn = ({ store, actionToDispatch, customStyle }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const onClickHandler = (name) => {
    dispatch(actionToDispatch({ queries: name[0].toUpperCase() })).then((response) => {
      if (response.meta.requestStatus === 'rejected') {
        enqueueSnackbar('Could not set summary type', { variant: 'error' })
      }
    })
  }

  return (
    <Box sx={[styles.summariesContainer, customStyle]}>
      {Object.entries(store.summaries || [])?.map((singleSummary) => (
        <Button
          sx={styles.summaryBtn}
          key={singleSummary[0]}
          onClick={() => onClickHandler(singleSummary)}
          className={`${store?.activeSummary === singleSummary[0].toUpperCase() && 'active'}`}
          disabled={!singleSummary[1]}>
          {singleSummary[0]}
          <span>{singleSummary[1]}</span>
        </Button>
      ))}
    </Box>
  )
}

const styles = {
  summariesContainer: {
    display: 'flex',
    marginLeft: { xs: 0, sm: '-5px' },
    width: '100%',
    paddingBottom: { xs: '10px', md: '0px' },
    justifyContent: { xs: 'space-evenly', md: 'normal' },
    overflowX: 'auto',
    '::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
  },
  summaryBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: { xs: '0.6rem', sm: '0.75rem' },
    border: 'solid 1px #d8dae6',
    height: { xs: '24px', sm: '32px' },
    padding: { xs: '4px 8px', md: '4px 16px' },
    margin: '0 5px',
    width: { xs: '25vw', lg: '100%' },
    maxWidth: '144px',
    minWidth: 'fit-content',
    borderRadius: '16px',
    backgroundColor: '#fff',
    color: 'text.primary',
    gap: '5px',
    span: {
      color: 'text.hint',
    },
    '&.active': {
      color: '#fff',
      borderColor: '#29cc8b',
      backgroundColor: '#29cc8b',
      span: {
        color: '#fff',
      },
    },
  },
}

export default SummariesBtn
